
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


window.addEventListener("load", () => {

    const sections = gsap.utils.toArray("section");
    sections.forEach((el) => {
        gsap.set(el, {opacity: 0, y: 128},);
    });

    const myFunction = () => {
        const sections = gsap.utils.toArray("section");
        sections.forEach((el) => {
            gsap.to(el, {
                y: 0,
                opacity: 1,
                duration: 1,
                ease: "power4.out",
                // スクロールトリガーの設定
                scrollTrigger: {
                    trigger: el, // 対象物
                },
            });
            gsap.from(el.querySelectorAll(".cardItem1,.serviceItem"), {
                start: "top top",
                opacity: 0,
                y: 100,
                duration: 2,
                stagger: 0.5,
                ease: "power4.out",
                // スクロールトリガーの設定
                scrollTrigger: {
                    trigger: el, // 対象物
                },
            });

        });

    }

    let mm = gsap.matchMedia();

    mm.add("(max-width: 640px)", (e) => {
        gsap.timeline(
            {
                // paused: true,
                defaults: {duration: 2}
            }).from(".mvImageSp", {opacity: 0, duration: 2, ease: "power4.out",})
            .to(".mvImageSp", {opacity: 1, duration: 0.3, ease: "power4.out",})

            .to(".homeMv__heading", {opacity: 1, duration: 0.1, ease: "power4.out", onComplete: myFunction},)

    });

    mm.add("(min-width: 641px)", (e) => {
        gsap.timeline(
            {
                // paused: true,
                defaults: {duration: 0}
            }).from(".mvImagePc", {opacity: 0, duration: 2, ease: "power4.out",})
            .to(".mvImagePc", {opacity: 1, duration: 2, ease: "power4.out",})

            .to(".homeMv__heading", {opacity: 1, duration: 1, ease: "power4.out", onComplete: myFunction},)

    });


});